let PrefixService = function () {

    const addPrefix = (value, type) => {
        if(!type || !value) {
            return value
        }

        const prefixChar = type[0].toUpperCase();
        const regex = new RegExp("^"+prefixChar);

        return (regex.test(value) ? '' : prefixChar) + value;
    }

    return {
        addPrefix
    }
}

PrefixService.$inject = []

export default PrefixService


// WEBPACK FOOTER //
// ./client/app/services/prefix.service.js